import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Grid,
  Switch,
  FormControlLabel,
} from "@mui/material";

const BrandForm = ({ handleClose, handleSubmit, initialData }) => {
  const [organizations, setOrganizations] = useState([]);
  const [formData, setFormData] = useState({
    org_id: "",
    name: "",
    segment: "",
    description: "",
    logo_url: "",
    style_guide: "",
    is_active: true,
  });

  const segments = ["LUXURY", "UPSCALE", "MIDSCALE", "ECONOMY", "BUDGET"];

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
        style_guide: initialData.style_guide
          ? JSON.stringify(initialData.style_guide, null, 2)
          : "",
      });
    }

    // Fetch organizations
    const fetchOrganizations = async () => {
      try {
        const response = await fetch(
          "https://api.esthell.com/HotelOrganization",
        );
        if (response.ok) {
          const data = await response.json();
          if (data.success && Array.isArray(data.data)) {
            setOrganizations(data.data);
          }
        }
      } catch (error) {
        console.error("Error fetching organizations:", error);
      }
    };

    fetchOrganizations();
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    try {
      // Validate style_guide JSON if not empty
      if (formData.style_guide) {
        JSON.parse(formData.style_guide);
      }
      handleSubmit(formData);
    } catch (err) {
      alert("Invalid JSON format in Style Guide");
    }
  };

  return (
    <Box
      component="form"
      onSubmit={onSubmit}
      sx={{ p: 2, bgcolor: "background.paper", borderRadius: 2, boxShadow: 1 }}
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: 16,
          fontWeight: "600",
          color: "#000",
          fontFamily: "Public Sans",
          mb: 2,
        }}
      >
        {initialData ? "Update Brand" : "New Brand"}
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            select
            required
            name="org_id"
            label="Organization Name"
            value={formData.org_id}
            onChange={handleChange}
            sx={{ "& .MuiInputBase-root": { height: "35px" } }}
          >
            <MenuItem value="">
              <em>Select Organization</em>
            </MenuItem>
            {organizations.map((org) => (
              <MenuItem key={org.id} value={org.org_id}>
                {org.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            required
            fullWidth
            size="small"
            name="name"
            label="Brand Name"
            value={formData.name}
            onChange={handleChange}
            sx={{ "& .MuiInputBase-root": { height: "35px" } }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            select
            size="small"
            name="segment"
            label="Segment"
            value={formData.segment || ""}
            onChange={handleChange}
            sx={{ "& .MuiInputBase-root": { height: "35px" } }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {segments.map((segment) => (
              <MenuItem key={segment} value={segment}>
                {segment}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            name="logo_url"
            label="Logo URL"
            value={formData.logo_url || ""}
            onChange={handleChange}
            sx={{ "& .MuiInputBase-root": { height: "35px" } }}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            name="description"
            label="Description"
            value={formData.description || ""}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            name="style_guide"
            label="Style Guide (JSON)"
            value={formData.style_guide || ""}
            onChange={handleChange}
            placeholder='{"primary_color": "#000000", "font_family": "Arial"}'
            helperText="Enter valid JSON format"
          />
        </Grid>

        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={formData.is_active}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    is_active: e.target.checked,
                  }))
                }
              />
            }
            label="Active"
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end", mt: 2 }}>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary">
          {initialData ? "Update" : "Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default BrandForm;
